import * as Yup from "yup";

export default Yup.object().shape({
  creditAmount: Yup.number()
    .typeError("Credit amount must be a number")
    .required("Credit amount is required")
    .min(0, "Credit amount cannot be negative"),

  reason: Yup.string().required("Adjustment reason is required"),

  description: Yup.string()
    .max(500, "Description cannot exceed 500 characters")
    .when("reason", {
      is: "Other",
      then: (schema) => schema.required("Please provide reason when 'Other' is selected"),
      otherwise: (schema) => schema.notRequired(),
    }),
});
